import React from "react";
import { Button, Modal, Row } from "react-bootstrap";
import {
  addContactAction,
  getContactByEmailAction,
  getUserRolesAction,
  addUserRolesAction,
} from "../../actions/UserActions";
import { connect } from "react-redux";
import * as Yup from "yup";
import { Field, Form, Formik, ErrorMessage } from "formik";
import InputMask from "react-input-mask";
import { cryptoTokenDecode, toastMessage } from "./../Common/Common";
import * as constant from "./../../config/Constants";
import * as message from "./../../config/CommonMessages";
import UrlConstants from "../../config/UrlConstants";
import { HexColorPicker } from "react-colorful";

class CreateContact extends React.Component {
  constructor(props) {
    super(props);
    let currentType = localStorage.getItem("currentRole");
    this.state = {
      page: 0,
      isEmailValid: false,
      isRoleExist: false,
      unauthorized: false,
      roleForPopup: this.props.roleForPopup,
      roleIdForPopup: this.props.roleIdForPopup,
      contact: {
        role: "",
        usertype:
          window.location.href === UrlConstants.SiteUrl + "contacts"
            ? message.VENDOR
            : message.BUYER,
        firstname: "",
        lastname: "",
        mobileNumber: "",
        email: "",
        color: "",
        ownerId:
          cryptoTokenDecode().usertype === message.ACCTOWNER
            ? localStorage.getItem("ID")
            : localStorage.getItem("ownerId"),
      },
      saveType: "",
      sameContingency: false,
      currentRole: !!currentType ? currentType.toUpperCase() : "",
    };
  }

  componentWillMount() {
    var userType = cryptoTokenDecode().usertype;

    if (
      userType === message.ADMIN ||
      (userType === message.VENDOR &&
        this.state.currentRole === message.BUYERAGENT)
    ) {
      this.props.getUserRolesAction("?id=" + localStorage.getItem("ownerId"));
    } else {
      this.props.getUserRolesAction();
    }
  }

  /**
   * @desc action on next button clicked
   * checking email is already exist or not
   * if email exist then load user's data to modal
   * if not exist then show empty form for contact details
   */
  next(email, role, errors, setFieldError) {
    if (email != "" && errors["email"] == undefined) {
      this.props.getContactByEmailAction(email).then((res) => {
        if (res == "Unauthorized") {
          this.setState({
            unauthorized: true,
          });
        } else {
          if (Object.keys(res).length > 0) {
            if (res.isDeleted && res.isDeleted == true) {
              this.setState({
                unauthorized: true,
              });
            } else {
              var contact = {
                role: res.role ? res.role[0] : "",
                usertype:
                  window.location.href === UrlConstants.SiteUrl + "contacts"
                    ? message.VENDOR
                    : message.BUYER,
                firstname: res.firstname,
                lastname: res.lastname,
                mobileNumber: res.mobileNumber,
                email: email,
                companyName: !!res.companyInformation
                  ? res.companyInformation.name
                  : "",
                color: res.color,
                ownerId:
                  cryptoTokenDecode().usertype === message.ACCTOWNER
                    ? localStorage.getItem("ID")
                    : localStorage.getItem("ownerId"),
              };
              this.setState({
                isEmailValid: true,
                unauthorized: false,
                isRoleExist: res.role ? true : false,
                contact,
              });
            }
          }
          this.setState({ page: 1 });
        }
      });
    }
  }

  /**
   * @desc add contact
   * check if user selected custom role then first add that role using api
   * and then add user/contact with details by add contact api
   */
  addContact(values) {
    var userType = cryptoTokenDecode().usertype;

    if (this.props.transactionData) {
      values["ownerId"] = this.props.transactionData.ownerId;

      if (
        userType.toUpperCase() === message.VENDOR &&
        this.state.currentRole === message.BUYERAGENT
      ) {
        values["rolename"] = "ep";
      }
    }

    if (values.role == "other") {
      let userRoleData = {};
      userRoleData.name = values.other.toUpperCase();

      if (
        userType.toUpperCase() == message.ACCTOWNER ||
        (userType.toUpperCase() === message.VENDOR &&
          this.state.currentRole === message.BUYERAGENT)
      ) {
        userRoleData.ownerId = localStorage.getItem("ID");
      }

      values.companyInformation = { name: values.companyName };
      delete values.companyName;

      this.props.addUserRolesAction(userRoleData).then((userRes) => {
        if (userRes.status === constant.OK) {
          values["roles"] = [userRes.data._id];
          values.mobileNumber = Number(values.mobileNumber);

          this.props.addContactAction(values).then((res) => {
            this.props.onClose();
          });
        } else if (userRes.status === constant.CONFLICT) {
          toastMessage(constant.ERROR, userRes.data);
          this.props.onClose();
        }
      });
    } else {
      values["roles"] = [values.role];
      values.mobileNumber = Number(values.mobileNumber);
      values.email = values.email.toLowerCase();
      values.companyInformation = { name: values.companyName };
      delete values.companyName;

      this.props.addContactAction(values).then((res) => {
        if (res.status === constant.FORBIDDEN) {
          this.setState({
            sameContingency: true,
          });
        } else if (res.status === constant.BAD_REQUEST) {
          toastMessage(constant.ERROR, res.data);
        } else {
          this.props.onClose();
        }
      });
    }
  }

  setFieldValue(name, e) {
    var contact = this.state.contact;
    contact[name] = e;
    this.setState({
      contact,
    });
  }

  setMobile(value, field, setFieldValue) {
    var mob = value.replace(/-/g, "");
    setFieldValue(field, mob);
  }

  handleColorAvailability(color, isColorUsed) {
    let contactColors = [];
    if (this.props.contacts.length > 0) {
      for (let i = 0; i < this.props.contacts.length; i++) {
        let contactColor = this.props.contacts[i].color;
        contactColors.push(contactColor);
        if (contactColors.includes(color)) {
          isColorUsed = true;
        } else {
          isColorUsed = false;
        }
      }
      return isColorUsed;
    }
  }

  render() {
    return (
      <div>
        <Modal.Body>
          <Formik
            validateOnBlur={true}
            initialValues={this.state.contact}
            enableReinitialize={true}
            validationSchema={Yup.object().shape({
              firstname: Yup.string()
                .trim()
                .required(message.ENTER_FIRST_NAME),
              lastname: Yup.string()
                .trim()
                .required(message.ENTER_LAST_NAME),
              // role: Yup.string().trim().required(message.REQUIRED_VENDOR_TYPE),
              email: Yup.string()
                .trim()
                .email(message.ENTER_VALID_EMAIL)
                .required(message.ENTER_EMAIL),
              mobileNumber: Yup.string()
                .nullable()
                .required(message.ENTER_MOBILE_NUMBER)
                .test("mobileNumber", message.ENTER_VALID_MOBILE, (value) => {
                  if ((value || "").length == 10) {
                    return true;
                  }
                  return false;
                }),
              //color: Yup.string().required(message.ENTER_COLOR)
            })}
            onSubmit={(values, errors) => {
              values.role = document.getElementById("ddlRole").value;
              if (this.state.saveType != "next") {
                this.addContact(values);
              }
            }}
          >
            {({ handleChange, values, errors, setFieldValue }) => (
              <Form className="form-sm form-admin">
                {this.state.page == 0 && (
                  <>
                    <div className="form-group">
                      <label>
                        Email<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        className="form-control"
                        name="email"
                        value={values.email}
                        onChange={(e) => {
                          setFieldValue("email", e.target.value);
                          this.setState({ unauthorized: false });
                        }}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                      {this.state.unauthorized && (
                        <label
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          User already exists as a client.
                        </label>
                      )}
                    </div>
                    <Button
                      variant="primary"
                      size="sm"
                      className="btn-blue w-140"
                      type="submit"
                      onClick={() => {
                        this.setState({ saveType: "next" }, () => {
                          this.next(values.email, values.role, errors);
                        });
                      }}
                    >
                      Next
                    </Button>
                  </>
                )}
                {this.state.page == 1 && (
                  <>
                    <div className="form-group">
                      <label>Email</label>
                      <Field
                        type="email"
                        className="form-control"
                        name="email"
                        disabled
                        value={values.email}
                        handleChange={handleChange}
                      />
                      <ErrorMessage
                        name="email"
                        component="div"
                        className="invalid-feedback"
                        style={{ display: "block" }}
                      />
                      {this.state.unauthorized ? (
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          User already exists.
                        </div>
                      ) : (
                        this.state.sameContingency && (
                          <div
                            className="invalid-feedback"
                            style={{ display: "block" }}
                          >
                            User already exists in this role.
                          </div>
                        )
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Role<span className="text-danger"> *</span>
                      </label>
                      {this.state.roleIdForPopup == undefined ? (
                        <select
                          className="form-control"
                          id="ddlRole"
                          name="role"
                          value={values.role}
                          onChange={(e) => {
                            setFieldValue("role", e.target.value);
                          }}
                          disabled
                        >
                          {this.props.roles &&
                            this.props.roles
                              .filter((role) =>
                                window.location.href ===
                                UrlConstants.SiteUrl + "contacts"
                                  ? role.name === "Artist"
                                  : role.name === "Client"
                              )
                              .map((role) => {
                                return (
                                  <option value={role._id}>{role.name}</option>
                                );
                              })}
                        </select>
                      ) : (
                        <select
                          className="form-control"
                          id="ddlRole"
                          name="role"
                          value={this.state.roleIdForPopup}
                          onChange={(e) => {
                            setFieldValue("role", e.target.value);
                          }}
                          disabled
                        >
                          <option value={this.state.roleIdForPopup}>
                            {this.state.roleForPopup}
                          </option>
                        </select>
                      )}

                      {this.state.saveType != "next" && (
                        <ErrorMessage
                          name="role"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        First Name<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        name="firstname"
                        className="form-control field_ucfirst"
                        value={values.firstname}
                        disabled={this.state.isEmailValid}
                        handleChange={handleChange}
                      />
                      {this.state.saveType != "next" && (
                        <ErrorMessage
                          name="firstname"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      )}
                    </div>
                    <div className="form-group">
                      <label>
                        Last Name<span className="text-danger"> *</span>
                      </label>
                      <Field
                        type="text"
                        name="lastname"
                        className="form-control field_ucfirst"
                        value={values.lastname}
                        disabled={this.state.isEmailValid}
                        handleChange={handleChange}
                      />
                      {this.state.saveType != "next" && (
                        <ErrorMessage
                          name="lastname"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      )}
                    </div>
                    <div
                      className="form-group"
                      hidden={this.state.isEmailValid}
                    >
                      <label>
                        Phone<span className="text-danger"> *</span>
                      </label>
                      <InputMask
                        mask="999-999-9999"
                        maskChar=""
                        formControlProps={{
                          fullWidth: true,
                        }}
                        className="form-control"
                        value={values.mobileNumber}
                        name="mobileNumber"
                        disabled={this.state.isEmailValid}
                        onChange={(e) => {
                          this.setMobile(
                            e.target.value,
                            "mobileNumber",
                            setFieldValue
                          );
                        }}
                      >
                        {(inputProps) => <Field {...inputProps} />}
                      </InputMask>
                      {this.state.saveType != "next" && (
                        <ErrorMessage
                          name="mobileNumber"
                          component="div"
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        />
                      )}
                    </div>
                    {window.location.href ===
                      UrlConstants.SiteUrl + "contactsnew" ||
                    window.location.href ===
                      UrlConstants.SiteUrl + "contacts" ? (
                      <div>
                        <label>
                          Choose a Color<span className="text-danger"> *</span>
                        </label>
                        <Row className="ml-1 mb-4 mt-2">
                          <HexColorPicker
                            color={this.state.contact.color}
                            onChange={(e) => setFieldValue("color", e)}
                            style={{ width: "420px", height: "100px" }}
                          />
                          {/* this.state.saveType != 'next' && <ErrorMessage name="color" component="div" className="invalid-feedback" style={{ display: "block", marginBottom: "20px" }} />*/}
                        </Row>
                        {/* <Row className='ml-1 mb-2'>
                          <button
                            onClick={() => setFieldValue("color", "red")}
                            value={values.color}
                            className='contact-color-btn-red'
                            disabled={this.handleColorAvailability("red", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "orange")}
                            value={values.color}
                            className='contact-color-btn-orange'
                            disabled={this.handleColorAvailability("orange", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "gold")}
                            value={values.color}
                            className='contact-color-btn-gold'
                            disabled={this.handleColorAvailability("gold", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "green")}
                            value={values.color}
                            className='contact-color-btn-green'
                            disabled={this.handleColorAvailability("green", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "blue")}
                            value={values.color}
                            className='contact-color-btn-blue'
                            disabled={this.handleColorAvailability("blue", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "purple")}
                            value={values.color}
                            className='contact-color-btn-purple'
                            disabled={this.handleColorAvailability("purple", true)}
                          />
                        </Row>
                        <Row className='ml-1 mb-2'>
                          <button
                            onClick={() => setFieldValue("color", "pink")}
                            value={values.color}
                            className='contact-color-btn-pink'
                            disabled={this.handleColorAvailability("pink", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "fuchsia")}
                            value={values.color}
                            className='contact-color-btn-fuchsia'
                            disabled={this.handleColorAvailability("fuchsia", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "cyan")}
                            value={values.color}
                            className='contact-color-btn-cyan'
                            disabled={this.handleColorAvailability("cyan", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "lime")}
                            value={values.color}
                            className='contact-color-btn-lime'
                            disabled={this.handleColorAvailability("lime", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "darkslategray")}
                            value={values.color}
                            className='contact-color-btn-darkslategray'
                            disabled={this.handleColorAvailability("darkslategray", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "lightcoral")}
                            value={values.color}
                            className='contact-color-btn-lightcoral'
                            disabled={this.handleColorAvailability("lightcoral", true)}
                          />
                        </Row>
                        <Row className='ml-1 mb-5'>
                          <button
                            onClick={() => setFieldValue("color", "lightgreen")}
                            value={values.color}
                            className='contact-color-btn-lightgreen'
                            disabled={this.handleColorAvailability("lightgreen", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "lightsalmon")}
                            value={values.color}
                            className='contact-color-btn-lightsalmon'
                            disabled={this.handleColorAvailability("lightsalmon", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "darkred")}
                            value={values.color}
                            className='contact-color-btn-darkred'
                            disabled={this.handleColorAvailability("darkred", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "darkslateblue")}
                            value={values.color}
                            className='contact-color-btn-darkslateblue'
                            disabled={this.handleColorAvailability("darkslateblue", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "darkcyan")}
                            value={values.color}
                            className='contact-color-btn-darkcyan'
                            disabled={this.handleColorAvailability("darkcyan", true)}
                          />
                          <button
                            onClick={() => setFieldValue("color", "darkorchid")}
                            value={values.color}
                            className='contact-color-btn-darkorchid'
                            disabled={this.handleColorAvailability("darkorchid", true)}
                          />
                        </Row> */}
                      </div>
                    ) : (
                      ""
                    )}
                    {this.state.isRoleExist && (
                      <Button
                        variant="primary"
                        size="sm"
                        className="btn-blue w-140"
                        onClick={() => {
                          this.props.onClose();
                        }}
                      >
                        {this.state.isEmailValid ? "Close" : "Add"}
                      </Button>
                    )}
                    {!this.state.isRoleExist && (
                      <Button
                        variant="primary"
                        disabled={this.state.unauthorized}
                        size="sm"
                        className="btn-blue w-140"
                        type="submit"
                        onClick={() => {
                          this.setState({ saveType: "" });
                        }}
                      >
                        {this.state.isEmailValid ? "Save" : "Add"}
                      </Button>
                    )}
                  </>
                )}
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    contactResponse: state.reducer.contactResponse,
    contact: state.reducer.contact,
    roles: state.reducer.roles,
  };
};

export default connect(
  mapStateToProps,
  {
    addContactAction,
    getContactByEmailAction,
    getUserRolesAction,
    addUserRolesAction,
  }
)(CreateContact);
